import * as React from 'react';
import { DisplayLosingStreak } from './DisplayLosingStreak';
import { DisplayWinningStreak } from './DisplayWinningStreak';

export function DisplayStreak({
	goodStreakLength,
	badStreakLength,
	maxGoodStreakLength
}: {
	goodStreakLength?: number;
	badStreakLength?: number;
	maxGoodStreakLength: number;
}) {
	return (
		<span>
			<DisplayLosingStreak badStreakLength={badStreakLength} />
			<DisplayWinningStreak
				goodStreakLength={goodStreakLength}
				badStreakLength={badStreakLength}
				maxGoodStreakLength={maxGoodStreakLength}
			/>
		</span>
	);
}
